import { DatosGenerales, getVoidDatosGenerales } from "./DatosGenerales";
import { ObjEspecifico } from "./ObjEspecificos";
import { ObjODS } from "./ObjODS";

export interface ProyectoDatosGenerales{
    datosGenerales: DatosGenerales,
    objEspecificos: Array<ObjEspecifico>,
    objODS: Array<ObjODS>,
    idInvestigador: number
}

export function GetVoidProyectoDatosGenerales(){
    return{
        datosGenerales: getVoidDatosGenerales(),
        objEspecificos: [],
        objODS: [],
        idInvestigador: 0
    }
}